import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY = '/reports/campaign/<id>/group/stats';

export function useCampaignGroupReportStatsQuery({
	campaignId,
	tags,
	impersonationContext,
	enabled = true,
}: {
	campaignId: string;
	tags: string[];
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
}) {
	const userSession = useUserSession();
	return useQuery({
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.ICampaignGroup>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `reports/campaign/${encodeURIComponent(campaignId)}/group/stats`,
					impersonationContext,
				}),
				'POST',
				{
					filter: {
						criteria: tags.map(value => ({
							property: Api.ContactFilterCriteriaProperty.Tag,
							value,
						})),
					},
				}
			),
		queryKey: [BASE_QUERY, campaignId, [...tags].sort(), impersonationContext?.account?.id],
		enabled: enabled && tags.length > 0,
	});
}
